import { ComponentProps } from 'preact';
import { Button } from '../UNSAFE_Button';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { mobileDropdownFooterStyles } from './themes/MobileDropdownFooterStyles.css';

type ButtonProps = ComponentProps<typeof Button>;
type Props = {
  onApply?: ButtonProps['onAction'];
};

export function MobileDropdownFooter({ onApply }: Props) {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  return (
    <div class={mobileDropdownFooterStyles.base}>
      <Button
        display="label"
        edge="bottom"
        label={translations.selectMultiple_apply()}
        size="sm"
        variant="callToAction"
        onAction={onApply}
      />
    </div>
  );
}
